<template>
  <v-footer app>
    <span>&copy; 2019 Imersys</span>
  </v-footer>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>